import baseURL from "./../api";
import axios from "axios";

class LoginService {
  constructor() {
    this.time = new Date().getTime();
}
    userLogin(data) {
    
        return axios.post(`${baseURL}/auth/authenticate?${this.time}`,data);
      }

      getAccessToken(){
        const token = JSON.parse(localStorage.getItem("token"));
        return token;
      }
      setAccessToken(userInfo){
        localStorage.setItem("token", JSON.stringify(userInfo.access_token));
      }

      deleteAccessToken(){
        localStorage.removeItem('persist:root');
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        //localStorage.clear();
      }

      verifyEmail(data) {
        return axios.post(`${baseURL}/auth/forgot-password?${this.time}`,data);

      }

      resetPassword(data) {
        return axios.post(`${baseURL}/auth/reset-password?${this.time}`,data);

      }
      newOTP(data) {
        return axios.post(`${baseURL}/auth/forgot-password/resend-otp?${this.time}`,data);

      }


}
export default new LoginService();